/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
};

/** Access grant objects enumeration for tenant access control. */
export enum AccessGrantObject {
  Account = 'ACCOUNT',
  EnterprisePackage = 'ENTERPRISE_PACKAGE',
  Subscription = 'SUBSCRIPTION'
}

export type GqlAutoscanSetting = {
  __typename?: 'GQLAutoscanSetting';
  enabled: Scalars['Boolean']['output'];
  platform: Scalars['String']['output'];
  platformUserId: Scalars['String']['output'];
};

export type GqlImpactMetrics = {
  __typename?: 'GQLImpactMetrics';
  overallScore: Maybe<Scalars['Float']['output']>;
  overallStatus: Maybe<ScoreStatus>;
};

export type GqloAuthOption = {
  __typename?: 'GQLOAuthOption';
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type GqlScheduledAutoscan = {
  __typename?: 'GQLScheduledAutoscan';
  platform: Scalars['String']['output'];
  platformUserId: Scalars['String']['output'];
  scheduledTaskId: Scalars['Int']['output'];
};

export type GqlTenant = {
  __typename?: 'GQLTenant';
  fullAccessGrantObjects: Maybe<Array<Maybe<AccessGrantObject>>>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  oauthOptions: Maybe<Array<Maybe<GqloAuthOption>>>;
  previewAccessGrantObjects: Maybe<Array<Maybe<AccessGrantObject>>>;
  trialAccessGrantObjects: Maybe<Array<Maybe<AccessGrantObject>>>;
};

export type GqlUser = {
  __typename?: 'GQLUser';
  autoscanSettings: Array<GqlAutoscanSetting>;
  email: Scalars['String']['output'];
  hasActivePlan: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  impactMetrics: Maybe<GqlImpactMetrics>;
  name: Maybe<Scalars['String']['output']>;
  nextAutoscanDate: Maybe<Scalars['DateTime']['output']>;
  planExpiresOn: Maybe<Scalars['DateTime']['output']>;
  planType: PlanType;
  registeredOn: Scalars['DateTime']['output'];
  scheduledAutoscans: Array<GqlScheduledAutoscan>;
  trialExpiresOn: Maybe<Scalars['DateTime']['output']>;
  trialPlatform: Maybe<Scalars['String']['output']>;
};

export type GqlUserFeatureVector = {
  __typename?: 'GQLUserFeatureVector';
  concernAccountSecurity: Maybe<Scalars['Float']['output']>;
  concernAccountSeparation: Maybe<Scalars['Float']['output']>;
  concernChildSafety: Maybe<Scalars['Float']['output']>;
  concernDataMisuse: Maybe<Scalars['Float']['output']>;
  concernDigitalWellness: Maybe<Scalars['Float']['output']>;
  concernOnlineAbuse: Maybe<Scalars['Float']['output']>;
  concernPhysicalSafety: Maybe<Scalars['Float']['output']>;
  isFacebookActive: Maybe<Scalars['Float']['output']>;
  isInstagramActive: Maybe<Scalars['Float']['output']>;
  isLinkedinActive: Maybe<Scalars['Float']['output']>;
  isRedditActive: Maybe<Scalars['Float']['output']>;
  isStravaActive: Maybe<Scalars['Float']['output']>;
  isTwitterActive: Maybe<Scalars['Float']['output']>;
  isVenmoActive: Maybe<Scalars['Float']['output']>;
};

export type GetEmailExists = {
  __typename?: 'GetEmailExists';
  exists: Scalars['Boolean']['output'];
};

export type GetEnterpriseAuthRedirect = {
  __typename?: 'GetEnterpriseAuthRedirect';
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type GetEnterpriseIsValidStripeCode = {
  __typename?: 'GetEnterpriseIsValidStripeCode';
  isValid: Scalars['Boolean']['output'];
};

export type GetUserFeatureFlags = {
  __typename?: 'GetUserFeatureFlags';
  anonymousUserId: Maybe<Scalars['String']['output']>;
  result: Maybe<Scalars['JSONString']['output']>;
};

export enum Level {
  Debug = 'debug',
  Error = 'error',
  Info = 'info',
  Warn = 'warn'
}

export type LogInput = {
  anonymousUserId: Scalars['String']['input'];
  extensionInstallationId: InputMaybe<Scalars['String']['input']>;
  level: Level;
  message: Scalars['String']['input'];
  properties: InputMaybe<Scalars['JSONString']['input']>;
  userAccountId: InputMaybe<Scalars['String']['input']>;
};

/** For login with email password without 2fa. */
export type Login = {
  __typename?: 'Login';
  enterpriseSsoLoginUrl: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

/** For login with email password **with** 2fa. */
export type Login2fa = {
  __typename?: 'Login2fa';
  accessJwt: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  refreshJwt: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type MutationUnauth = {
  __typename?: 'MutationUnauth';
  getEmailExists: Maybe<GetEmailExists>;
  getEnterpriseAuthRedirect: Maybe<GetEnterpriseAuthRedirect>;
  getEnterpriseIsValidStripeCode: Maybe<GetEnterpriseIsValidStripeCode>;
  getUserFeatureFlags: Maybe<GetUserFeatureFlags>;
  log: Maybe<Scalars['Boolean']['output']>;
  /** For login with email password without 2fa. */
  login: Maybe<Login>;
  /** For login with email password **with** 2fa. */
  login2fa: Maybe<Login2fa>;
  requestEmailConfirmationEmail: Maybe<RequestEmailConfirmationEmail>;
  requestLogin2faCode: Maybe<RequestLogin2faSmsCode>;
  requestPasswordResetEmail: Maybe<RequestPasswordResetEmail>;
  resetPassword: Maybe<ResetPassword>;
  signUp: Maybe<SignUp>;
  track: Maybe<Scalars['String']['output']>;
};


export type MutationUnauthGetEmailExistsArgs = {
  email: Scalars['String']['input'];
};


export type MutationUnauthGetEnterpriseAuthRedirectArgs = {
  email: Scalars['String']['input'];
};


export type MutationUnauthGetEnterpriseIsValidStripeCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationUnauthGetUserFeatureFlagsArgs = {
  userFeatureFlagInput: UserFeatureFlagInput;
};


export type MutationUnauthLogArgs = {
  logInput: LogInput;
};


export type MutationUnauthLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUnauthLogin2faArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnauthRequestEmailConfirmationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUnauthRequestPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUnauthResetPasswordArgs = {
  jwt: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUnauthSignUpArgs = {
  email: Scalars['String']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationUnauthTrackArgs = {
  trackInput: TrackInput;
};

/** An enumeration. */
export enum PlanType {
  NoPlan = 'NO_PLAN',
  StandardPlan = 'STANDARD_PLAN',
  TrialPlan = 'TRIAL_PLAN'
}

export type QueryUnauth = {
  __typename?: 'QueryUnauth';
  defaultUserFeatures: Maybe<GqlUserFeatureVector>;
  healthCheck: Maybe<Scalars['String']['output']>;
  tenant: Maybe<GqlTenant>;
};


export type QueryUnauthTenantArgs = {
  tenantId: InputMaybe<Scalars['String']['input']>;
};

export type RequestEmailConfirmationEmail = {
  __typename?: 'RequestEmailConfirmationEmail';
  error: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type RequestLogin2faSmsCode = {
  __typename?: 'RequestLogin2faSmsCode';
  error: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type RequestPasswordResetEmail = {
  __typename?: 'RequestPasswordResetEmail';
  error: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  error: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum ScoreStatus {
  High = 'HIGH',
  Minimal = 'MINIMAL',
  Moderate = 'MODERATE'
}

export type SignUp = {
  __typename?: 'SignUp';
  error: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  user: Maybe<GqlUser>;
};

export type TrackInput = {
  anonymousUserId: InputMaybe<Scalars['String']['input']>;
  context: InputMaybe<Scalars['JSONString']['input']>;
  flags: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  properties: InputMaybe<Scalars['JSONString']['input']>;
  timestamp: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFeatureFlagInput = {
  anonymousUserId: InputMaybe<Scalars['String']['input']>;
  userAccountId: InputMaybe<Scalars['String']['input']>;
};

export type DefaultUserFeatureValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultUserFeatureValuesQuery = { __typename?: 'QueryUnauth', defaultUserFeatures: { __typename?: 'GQLUserFeatureVector', isTwitterActive: number | null, isFacebookActive: number | null, isVenmoActive: number | null, isStravaActive: number | null, isRedditActive: number | null, isLinkedinActive: number | null, isInstagramActive: number | null, concernAccountSecurity: number | null, concernAccountSeparation: number | null, concernChildSafety: number | null, concernDataMisuse: number | null, concernDigitalWellness: number | null, concernOnlineAbuse: number | null, concernPhysicalSafety: number | null } | null };

export type LogMutationVariables = Exact<{
  logInput: LogInput;
}>;


export type LogMutation = { __typename?: 'MutationUnauth', log: boolean | null };

export type GetUserFeatureFlagsMutationVariables = Exact<{
  userFeatureFlagInput: UserFeatureFlagInput;
}>;


export type GetUserFeatureFlagsMutation = { __typename?: 'MutationUnauth', getUserFeatureFlags: { __typename?: 'GetUserFeatureFlags', anonymousUserId: string | null, result: any | null } | null };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'QueryUnauth', tenant: { __typename?: 'GQLTenant', id: string | null, name: string | null, fullAccessGrantObjects: Array<AccessGrantObject | null> | null, trialAccessGrantObjects: Array<AccessGrantObject | null> | null, previewAccessGrantObjects: Array<AccessGrantObject | null> | null, oauthOptions: Array<{ __typename?: 'GQLOAuthOption', name: string | null, url: string | null } | null> | null } | null };


export const DefaultUserFeatureValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DefaultUserFeatureValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultUserFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isTwitterActive"}},{"kind":"Field","name":{"kind":"Name","value":"isFacebookActive"}},{"kind":"Field","name":{"kind":"Name","value":"isVenmoActive"}},{"kind":"Field","name":{"kind":"Name","value":"isStravaActive"}},{"kind":"Field","name":{"kind":"Name","value":"isRedditActive"}},{"kind":"Field","name":{"kind":"Name","value":"isLinkedinActive"}},{"kind":"Field","name":{"kind":"Name","value":"isInstagramActive"}},{"kind":"Field","name":{"kind":"Name","value":"concernAccountSecurity"}},{"kind":"Field","name":{"kind":"Name","value":"concernAccountSeparation"}},{"kind":"Field","name":{"kind":"Name","value":"concernChildSafety"}},{"kind":"Field","name":{"kind":"Name","value":"concernDataMisuse"}},{"kind":"Field","name":{"kind":"Name","value":"concernDigitalWellness"}},{"kind":"Field","name":{"kind":"Name","value":"concernOnlineAbuse"}},{"kind":"Field","name":{"kind":"Name","value":"concernPhysicalSafety"}}]}}]}}]} as unknown as DocumentNode<DefaultUserFeatureValuesQuery, DefaultUserFeatureValuesQueryVariables>;
export const LogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Log"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"log"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"logInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logInput"}}}]}]}}]} as unknown as DocumentNode<LogMutation, LogMutationVariables>;
export const GetUserFeatureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetUserFeatureFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFeatureFlagInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFeatureFlagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserFeatureFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userFeatureFlagInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFeatureFlagInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anonymousUserId"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<GetUserFeatureFlagsMutation, GetUserFeatureFlagsMutationVariables>;
export const TenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullAccessGrantObjects"}},{"kind":"Field","name":{"kind":"Name","value":"trialAccessGrantObjects"}},{"kind":"Field","name":{"kind":"Name","value":"previewAccessGrantObjects"}},{"kind":"Field","name":{"kind":"Name","value":"oauthOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TenantQuery, TenantQueryVariables>;